import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ValueWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;

  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
`;

export const TitleWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
